export default __webpack_public_path__ + "static/img-fishing-net-d30d0921b4a57520ec8b5291adb6f641.jpg";